import { render, staticRenderFns } from "./Finishes.vue?vue&type=template&id=2c14f3aa&scoped=true"
import script from "./Finishes.vue?vue&type=script&lang=js"
export * from "./Finishes.vue?vue&type=script&lang=js"
import style0 from "./Finishes.vue?vue&type=style&index=0&id=2c14f3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14f3aa",
  null
  
)

export default component.exports